module.exports = __webpack_public_path__ + "static/media/pexels-photo-3.9506b864.png";